import * as actions from '../actions/lawsysFirms';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestCheckLawsysFirmBankAccountValidity(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY)
		.map(action => ({
			url: BASE_URL + `api/erp/organisations/${action.payload.lawsysId}/validationstatus` ,
			category: 'requestCheckLawsysFirmBankAccountValidity',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestCheckLawsysFirmBankAccountValidity')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.checkLawsysFirmBankAccountValiditySuccess(response)); //JSON.parse(response.text))

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function requestCheckLawsysFirmBankAccountValidityFailed(sources) {
	let httpResponse$ = sources.HTTP
		.select('requestCheckLawsysFirmBankAccountValidity')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.checkLawsysFirmBankAccountValidityFailed(response));

	return {
		ACTION: httpResponse$
	}
}


export function getRequestLawsysFirmGroup(sources) {
	const request$ = sources.ACTION
        .filter(action =>( action.type === ActionTypes.NEW_SOLICITOR_UPDATE_LAWSYS_FIELD ||action.type === ActionTypes.REQUEST_LAWSYS_FIRM_GROUP))
        .map(action => ({
            url: BASE_URL + 'api/Groups/solicitors/Lawsys/' + action.payload.id ,
            category: 'getRequestLawsysFirmGroup',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getRequestLawsysFirmGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveLawsysFirmGroup(response)); //JSON.parse(response.text))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedGetRequestLawsysFirmGroup(sources) {
    let httpResponse$ = sources.HTTP
        .select('getRequestLawsysFirmGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveLawsysFirmGroup(response));

    return {
        ACTION: httpResponse$
    }
}


export function getLawsysAgentsFiltered(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_LAWSYS_FIRMS_FILTERED)
		.map(action => ({
			url: BASE_URL + 'api/users/GetLawsysAgentsFiltered?' + (action.payload.search?`search=${encodeURIComponent(action.payload.search)}`:'') ,
			category: 'lawsysAgentsFiltered',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('lawsysAgentsFiltered')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveLawsysFirmsFiltered(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetLawsysAgentsFiltered(sources) {
	let httpResponse$ = sources.HTTP
		.select('lawsysAgentsFiltered')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveLawsysFirmsFiltered([]));

	return {
		ACTION: httpResponse$
	}
}


export function getLawsysAgents(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_LAWSYS_FIRMS)
		.map(action => ({
			url: BASE_URL + 'api/users/GetLawsysAgents' ,
			category: 'lawsysAgents',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('lawsysAgents')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveLawsysFirms(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetLawsysAgents(sources) {
	let httpResponse$ = sources.HTTP
		.select('lawsysAgents')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveLawsysFirms([]));

	return {
		ACTION: httpResponse$
	}
}


export function getLawsysAgentsWithAgents(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_LAWSYS_FIRMS_WITH_AGENTS)
		.map(action => ({
			url: BASE_URL + 'api/users/GetLawsysAgentsWithAgents' ,
			category: 'lawsysAgentsWithAgents',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('lawsysAgentsWithAgents')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveLawsysFirmsWithAgents(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetLawsysAgentsWithAgents(sources) {
	let httpResponse$ = sources.HTTP
		.select('lawsysAgentsWithAgents')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveLawsysFirmsWithAgents([]));

	return {
		ACTION: httpResponse$
	}
}